class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.loadRecommendations(parsedState.product_id);
    this.open();
  }

  async loadRecommendations(productId) {
    const wrapper = document.getElementById('rs-cart-notification-upsell');
    const grid = document.getElementById('rs-cart-notification-upsell-grid');
    if (!wrapper || !grid || !productId) return;

    wrapper.hidden = true;
    grid.innerHTML = '';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const [recommendationsResponse, cartResponse] = await Promise.all([
        fetch(`${root}recommendations/products.json?product_id=${productId}&limit=8&intent=related`),
        fetch(`${root}cart.js`)
      ]);

      if (!recommendationsResponse.ok || !cartResponse.ok) return;

      const recommendationsData = await recommendationsResponse.json();
      const cartData = await cartResponse.json();
      const cartProductIds = new Set((cartData.items || []).map((item) => item.product_id));

      const products = (recommendationsData.products || [])
        .filter((product) => product.available !== false && !cartProductIds.has(product.id))
        .slice(0, 2);

      if (!products.length) return;

      const currency = wrapper.dataset.currency || cartData.currency || 'USD';
      const money = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
      });

      products.forEach((product) => {
        const card = document.createElement('div');
        card.className = 'rs-cart-notification-upsell-card';

        const productUrl = product.url || `${root}products/${product.handle}`;
        const imageUrl =
          product.featured_image ||
          (product.images && product.images.length ? product.images[0] : '');

        const imageLink = document.createElement('a');
        imageLink.href = productUrl;
        imageLink.className = 'rs-cart-notification-upsell-image';
        imageLink.setAttribute('aria-label', product.title);

        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = product.title;
          img.loading = 'lazy';
          imageLink.appendChild(img);
        }

        const info = document.createElement('div');
        info.className = 'rs-cart-notification-upsell-info';

        const title = document.createElement('a');
        title.href = productUrl;
        title.className = 'rs-cart-notification-upsell-title';
        title.textContent = product.title;

        const price = document.createElement('div');
        price.className = 'rs-cart-notification-upsell-price';
        price.textContent = money.format((product.price || 0) / 100);

        const action = document.createElement('a');
        action.href = productUrl;
        action.className = 'rs-cart-notification-upsell-action';
        action.textContent = 'Choose Options';

        info.append(title, price, action);
        card.append(imageLink, info);
        grid.appendChild(card);
      });

      wrapper.hidden = false;
    } catch (error) {
      wrapper.hidden = true;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
